var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo"}},[_vm._v("\n 你好\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }